export default {"src":"/_next/static/media/nango-icon.f09e1e8d.svg","height":66,"width":66,"blurWidth":0,"blurHeight":0};